import axios from "axios";
import { BASE_URL } from "./config";
import { applyFriendlyErrorMessage } from "./friendlyError";

// No auth token attached — use for login, register, forgot-password,
// public landing-page content, or any endpoint that doesn't require a session.
//
// withCredentials: true is required here because /auth/login sets the
// refresh token as an HttpOnly cookie in its response — the browser only
// stores/sends that cookie on cross-origin requests if this flag is set.
export const publicClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

publicClient.interceptors.response.use((response) => response, applyFriendlyErrorMessage);